/*
 * @描叙: 格式化表计状态 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-18 14:35:31 
*/

export function fmtData(data) {
    return data.map(v=>{
        let obj = {};
        obj.oid = v.terminalid;
        obj.terminalid = v.terminalid;
		if(v["device-model"] == 'FC890' || v["device-model"] == 'FC900C'){
			obj.type = 2;
		}else{
			obj.type = 1;
		}
        
        obj["device-model"] = v["device-model"];
        obj["device-serial"] = v["device-serial"];
        obj.status = v.status;
        obj.householdname = v.householdname;
        obj.housename = v.housename;

        obj._data = Object.assign({}, v.data);   //  保存原始数据
        // let {
        //     antifreezing,
        //     key_lock, mode,
        //     model,
        //     op_at_acback,
        //     power_on,
        //     room_temperature,
        //     speed,
        //     temperature,
        //     temperature_dl,
        //     temperature_ul,
        //     time_hour,
        //     time_minute,
        //     time_second,
        //     valve_on,
        //     version, } = v.data;
        // obj = Object.assign(obj, { antifreezing, key_lock, mode, model, op_at_acback, power_on, room_temperature, speed, temperature, temperature_dl, temperature_ul, time_hour, time_minute, time_second, valve_on, version, })      
        if(v["device-model"] == 'FC890'){
        	//设置温度
        	if(v.data.setting_mode == "1"){
        		obj.temperature = ((v.data.setting_cooling_temperature)/10).toFixed(2)
        	}else if(v.data.setting_mode == "8"){
        		obj.temperature = ((v.data.setting_heating_temperature)/10).toFixed(2)
        	}else{
        		obj.temperature = ""
        	}
			obj.room_temperature = ((v.data.tsensor_value) / 10).toFixed(2)
        	if(v.data.setting_allow_ventilation == "0"){
        		obj.speed = 4
        	}else if(v.data.setting_allow_ventilation == "1"){
        		obj.speed = 5
        	}
        	//模式
        	if(v.data.setting_mode == "1"){
        		obj.mode = 0
        	}else if(v.data.setting_mode == "4"){
        		obj.mode = 1
        	}else if(v.data.setting_mode == "8"){
        		obj.mode = 2
        	}else{
        		obj.mode = 6
        	}
        	//模式
        	if(v.data.setting_power_on == "0"){
        		obj.power_on = 0
        	}else if(v.data.setting_power_on == "1"){
        		obj.power_on = 1
        	}
        	//按键锁
        	if(v.data.setting_key_lock == "1"){
        		obj.key_lock = 1
        	}else if(v.data.setting_key_lock == "2"){
        		obj.key_lock = 4
        	}else if(v.data.setting_key_lock == "4"){
        		obj.key_lock = 2
        	}else if(v.data.setting_key_lock == "8"){
        		obj.key_lock = 3
        	}else if(v.data.setting_key_lock == "128"){
        		obj.key_lock = 5
        	}else if(v.data.setting_key_lock == "0"){
        		obj.key_lock = 0
        	}
        }
		if(v["device-model"] == "FC226W"){
			//开关机
			if(v.data.powerStatus == "On"){
				obj.power_on = 1
			}else if(v.data.powerStatus == "Off"){
				obj.power_on = 0
			}
			//风速
			if(v.data.fanSpeed == "Auto"){
				obj.speed = 0
			}else if(v.data.fanSpeed == "High"){
				obj.speed = 1
			}else if(v.data.fanSpeed == "Medium"){
				obj.speed = 2
			}else if(v.data.fanSpeed == "Low"){
				obj.speed = 3
			}else{
				obj.speed = 8
			}
			//电磁阀
			if(v.data.waterValve == "On"){
				obj.valve_on = 1
			}else{
				obj.valve_on = 0
			}
			//模式
			if(v.data.workMode == "COOLING" || v.data.workMode == "Cool"){
				obj.mode = 0
			}else if(v.data.workMode == "Fan"){
				obj.mode = 1
			}else if(v.data.workMode == "Heat"){
				obj.mode = 2
			}else if(v.data.workMode == "Auto"){
				obj.mode = 3
			}else if(v.data.workMode == "AutoHeat"){
				obj.mode = 4
			}else if(v.data.workMode == "AutoCool"){
				obj.mode = 5
			}else{
				obj.mode = 6
			}
			//设置温度
			if(v.data.temperatureMode == "C"){
				obj.temperature = ((v.data.roomTemperatureSp)/10).toFixed(2)
				obj.temperatureMode = v.data.temperatureMode
			}else{
				obj.temperature = ((v.data.roomTemperatureSp / 10 * 1.8) + 32).toFixed(2)
			}
			//室内温度
			if(v.data.temperatureMode == "C"){
				obj.room_temperature = ((v.data.roomTemperature)/10).toFixed(2)
				obj.temperatureMode = v.data.temperatureMode
			}else{
				obj.room_temperature = ((v.data.roomTemperature / 10 * 1.8) + 32).toFixed(2)
			}
			//按键锁
			obj.key_lock = parseInt(v.data.keyBoardlock)
			
		}
        if(v["device-model"] == 'FC810'){
			if(v.data.valve1_on == "0" && v.data.valve2_on == "0"){
				obj.valve_on = 0
			}else if(v.data.valve1_on == "1"){
				obj.valve_on = 16
			}else if(v.data.valve1_on == "1"){
				obj.valve_on = 1
			}else{
				obj.valve_on = 4
			}
        	//风速
        	if(v.data.setting_speed == "128"){
        		obj.speed = 0
        	}else if(v.data.setting_speed == "8"){
        		obj.speed = 1
        	}else if(v.data.setting_speed == "4"){
        		obj.speed = 2
        	}else if(v.data.setting_speed == "2"){
        		obj.speed = 3
        	}else{
        		obj.speed = 8
        	}
        	//模式
        	if(v.data.setting_mode == "1"){
        		obj.mode = 0
        	}else if(v.data.setting_mode == "4"){
        		obj.mode = 1
        	}else if(v.data.setting_mode == "8"){
        		obj.mode = 2
        	}else{
        		obj.mode = 6
        	}
        	//开关机
        	if(v.data.setting_power_on == "0"){
        		obj.power_on = 0
        	}else if(v.data.setting_power_on == "1"){
        		obj.power_on = 1
        	}
        	//设置温度
        	obj.temperature = ((v.data.setting_temperature)/10).toFixed(2)
			obj.room_temperature = (v.data.room_temperature).toFixed(2)
        	//按键锁
        	if(v.data.setting_key_lock == "1"){
        		obj.key_lock = 1
        	}else if(v.data.setting_key_lock == "2"){
        		obj.key_lock = 4
        	}else if(v.data.setting_key_lock == "4"){
        		obj.key_lock = 2
        	}else if(v.data.setting_key_lock == "8"){
        		obj.key_lock = 3
        	}else if(v.data.setting_key_lock == "0"){
        		obj.key_lock = 0
        	}
        }
        //fc900c
        if(obj['device-model'] == 'FC900C'){
        	//模式
        	if(v.data.set_mode == "1"){
        		obj.mode = 0
        	}else if(v.data.set_mode == "2"){
        		obj.mode = 1
        	}else if(v.data.set_mode == "3"){
        		obj.mode = 2
        	}else{
        		obj.mode = 6
        	}
        	//设置温度
        	obj.temperature = (v.data.set_temp).toFixed(2)
			//室内温度
			obj.room_temperature = (v.data.temp).toFixed(2)
        	//开度
        	obj.twopipe_value = v.data.twopipe_value
        	//模式
        	if(v.data.power_on == "0"){
        		obj.power_on = 0
        	}else if(v.data.power_on == "1"){
        		obj.power_on = 1
        	}
        	//按键锁
        	if(v.data.key_lock == "1"){
        		obj.key_lock = 1
        	}else if(v.data.key_lock == "2"){
        		obj.key_lock = 4
        	}else if(v.data.key_lock == "4"){
        		obj.key_lock = 2
        	}else if(v.data.key_lock == "128"){
        		obj.key_lock = 5
        	}else if(v.data.key_lock == "0"){
        		obj.key_lock = 0
        	}
        	
        }
        //FC100CKM
        if(obj['device-model'] == "FC100CKM"){
			//电磁阀
			if(v.data.value_status == "1"){
				obj.valve_on = 2
			}else{
				obj.valve_on = 0
			}
        	//风速
        	if(v.data.set_speed == "2"){
        		obj.speed = 3
        	}else if(v.data.set_speed == "4"){
        		obj.speed = 2
        	}else if(v.data.set_speed == "8"){
        		obj.speed = 1
        	}else if(v.data.set_speed == "128"){
        		obj.speed = 0
        	}else{
        		obj.speed = 8
        	}
        	//模式
        	if(v.data.set_mode == "1"){
        		obj.mode = 0
        	}else if(v.data.set_mode == "4"){
        		obj.mode = 1
        	}else if(v.data.set_mode == "8"){
        		obj.mode = 2
        	}else if(v.data.set_mode == "16"){
        		obj.mode = 3
        	}else{
        		obj.mode = 6
        	}
        	//设置温度
        	obj.temperature = v.data.set_temp
			//室内温度
			obj.room_temperature = v.data.temp
        	//模式
        	if(v.data.power_on == "0"){
        		obj.power_on = 0
        	}else if(v.data.power_on == "1"){
        		obj.power_on = 1
        	}
        }
		//fc900c
		if(obj['device-model'] == "FC100CKB"){
			//电磁阀
			if(v.data.value == "1"){
				obj.valve_on = 2
			}else{
				obj.valve_on = 0
			}
			//风速
			if(v.data.setting_speed == "2"){
				obj.speed = 3
			}else if(v.data.setting_speed == "4"){
				obj.speed = 2
			}else if(v.data.setting_speed == "8"){
				obj.speed = 1
			}else if(v.data.setting_speed == "128"){
				obj.speed = 0
			}else{
				obj.speed = 8
			}
			//模式
			if(v.data.setting_model == "1"){
				obj.mode = 0
			}else if(v.data.setting_model == "4"){
				obj.mode = 1
			}else if(v.data.setting_model == "8"){
				obj.mode = 2
			}else if(v.data.setting_model == "16"){
				obj.mode = 3
			}else{
				obj.mode = 6
			}
			//设置温度
			obj.temperature = ((v.data.setting_temp)/10).toFixed(2)
			//室内温度
			obj.room_temperature = ((v.data.temp_air)/10).toFixed(2)
			//模式
			if(v.data.power_on == "0"){
				obj.power_on = 0
			}else if(v.data.power_on == "1"){
				obj.power_on = 1
			}
			//按键锁
			if(v.data.setting_key_lock == "1"){
				obj.key_lock = 1
			}else if(v.data.setting_key_lock == "2"){
				obj.key_lock = 4
			}else if(v.data.setting_key_lock == "4"){
				obj.key_lock = 2
			}else if(v.data.setting_key_lock == "128"){
				obj.key_lock = 5
			}else if(v.data.setting_key_lock == "0"){
				obj.key_lock = 0
			}
		}
        if(v["device-model"] == 'FC109R'){
        	let {
        		antifreezing, 
        		key_lock, mode, 
        		model, 
        		op_at_acback, 
        		power_on, 
        		room_temperature, 
        		speed,
        		temperature, 
        		temperature_dl, 
        		temperature_ul,
        		time_hour,
        		time_minute,
        		time_second,
        		valve_on,
        		version, } = v.data;
        		obj = Object.assign(obj,{antifreezing, key_lock, mode,model,op_at_acback,power_on,room_temperature,speed,temperature,temperature_dl,temperature_ul,time_hour,time_minute,time_second,valve_on,version, } )      
            }
		return obj
    })
}

export function fmtMeterInfo(list) {
    if(list.length<=0) return []
    let arr = list.map(v=>{
        let obj = {}
        obj.terminalid = v.oid
        obj.DevType = v.type
		obj.model = v['device-model']
        obj.status = v.power_on === 1 ? '开机' : "关机";
        obj.speed = fmtSpeed(v.speed)
        obj.mode = fmtMode(v.mode);
        obj.valveon = fmtValve_on(v.valve_on);
        obj.temperature = v.temperature ? v.temperature + "°C" : '';
        obj.room_temperature = v.room_temperature ? v.room_temperature + "°C" : '';
        return obj;
    })
    return arr
}

function fmtMode(mode) {
    switch (mode) {
        case 0:
            return "制冷"
        case 1:
            return "通风"
        case 2:
            return "制热"
        case 3:
            return "自动"
        default:
            return ''
    }
}
function fmtValve_on(val) {
    switch (val) {
        case 0:
            return "全关"
        case 1:
            return "热水开"
		case 2:
		    return "开启"
        case 16:
            return "冷水开"
        default:
            return ''
    }
}
function fmtSpeed(val) {
    switch (val) {
        case 0:
            return "自动"
        case 1:
            return "高风"
        case 2:
            return "中风"
        case 3:
            return "低风"
		case 4:
		    return "禁用通风"
		case 5:
		    return "允许通风"
        default:
            return ''
    }
}